const initialState = {
  id: '',
  key: '',
  lastName: '',
  firstName: '',
  middleName: '',
  SSN: '',
  dateOfBirth: '',
  suffix: '',
  gender: '',
  ethnicityOrRace: '',
  veteran: '',
  deployedCombatDuty: '',
  diagnosedPostTraumaticStressDisorder: '',
  registration290: '',
  arsonist: '',
  newLoadedData: false,
};

export default initialState;
